/**
 * journal.ts — kid journal + imagination entries (PR-15 split of api/client.ts).
 *
 * Imagination uses the same backend table as journal but with kind='imagination',
 * so both kid-authored writing surfaces share one endpoint and one shape.
 *
 * 调用关系：
 *   - Merged into the unified `api` object via api/client.ts.
 *   - Used by JournalPage + ImaginationPage.
 *   - Backend: backend/src/routes/journal.js (kind=journal|imagination).
 *
 * 关键约束：
 *   - Pass `kind:'imagination'` when writing from the imagination flow so
 *     the entry shows on the right tab; default kind on the server is 'journal'.
 */
import type { JournalEntry } from '@xiaopeiban/shared';
import { call } from './_core';

export const journalApi = {
  // Journal
  listJournal() {
    return call<{ entries: JournalEntry[] }>('/api/v1/child/journal');
  },
  writeJournal(content: string, mood?: string, pet_id?: number) {
    return call<{ ok: true; id: number }>('/api/v1/child/journal', {
      method: 'POST', body: JSON.stringify({ content, mood, pet_id }),
    });
  },

  // Imagination — uses same journal endpoints with kind parameter
  listImagination(limit = 30) {
    return call<{ entries: JournalEntry[] }>(
      `/api/v1/child/journal?kind=imagination&limit=${limit}`,
    );
  },
  writeImagination(content: string, mood?: string) {
    return call<{ ok: true; id: number }>('/api/v1/child/journal', {
      method: 'POST',
      body: JSON.stringify({ content, mood, kind: 'imagination' }),
    });
  },
};
